module.exports = __webpack_public_path__ + "media/assets/images/group-number-625dfb8107042b40fbe85f9c2b2cdf19.svg";